import type { StringFilter, StringFilterableProperty } from "./string-filter";

const includeStringFilter = <
    T extends { [key in StringFilterableProperty]: string[] }
>(
    propsToFilter: StringFilterableProperty | StringFilterableProperty[],
    filter: StringFilter
) => (item: T | undefined): boolean => {
    if (typeof item === "undefined") return false;
    const itemsToFilter =
        typeof propsToFilter === "string"
            ? [propsToFilter]
            : propsToFilter.flatMap(p => item[p]);
    return filter?.include?.length
        ? filter.include.some(included =>
              itemsToFilter.some(value => value === included)
          )
        : true;
};

export { includeStringFilter };
